export default __webpack_public_path__ + "static/media/banner2-mobile.14c33524.png";